/*************************************************/
/* HEADER                                        */
/*************************************************/

export function menu(body) {
    const menuToggleButtonSelector = '.menu-nav-desktop__btn';
    const menuOverlayWrapSelector = '.menu-nav-desktop__overlay-wrap';
    const menuBlackoutSelector = '.menu-nav-desktop__overlay-blackout';
    const menuItemWithChildrenSelectore = '.menu-nav-desktop__link--parent';
    const subNavigationSelector =  '.menu-nav-desktop__sub-navigation';
    const activeClassName = 'active';
    const bodyActiveClassName = 'desktop-navigation-active';

    function toggleMenu(){
        const menuWrap = document.querySelector(menuOverlayWrapSelector);
        if (!menuWrap) return false;

        if (!menuWrap.classList.contains(activeClassName)) {
            menuWrap.classList.add(activeClassName);
            body.classList.add(bodyActiveClassName);
        } else if (menuWrap.classList.contains(activeClassName)) {
            menuWrap.classList.remove(activeClassName);
            body.classList.remove(bodyActiveClassName);

        }
    }

    const init = () => {

        const menuToggleButton = document.querySelector(menuToggleButtonSelector);
        if (menuToggleButton) {
            menuToggleButton.addEventListener('click', e => {
                //Yes, we could traverse up and find the relevant one, but there should only be one menu nonetheless
                toggleMenu();
            });
        }

        const menuBlackout = document.querySelector(menuBlackoutSelector);
        if(menuBlackout) {
            menuBlackout.addEventListener('click', e => {
                toggleMenu();
            });
        }


        const navItemsWithChildren = document.querySelectorAll(menuItemWithChildrenSelectore);
        const subNavigations = document.querySelectorAll(subNavigationSelector);
        if (navItemsWithChildren && subNavigations) {
            navItemsWithChildren.forEach(item => {
                item.addEventListener('click', e => {

                    const subNavigationId = item.dataset.subNavigationId;
                    if (!subNavigationId) return false;

                    const subNavigation = Array.from(subNavigations).find(x=>x.id == subNavigationId);
                    if (!subNavigation) return false;

                    subNavigations.forEach(subNavigation => {
                        subNavigation.classList.remove(activeClassName);
                    });

                    subNavigation.classList.add(activeClassName);

                });
            });
        }

    };

    init();

}

